const headers = {
  name: "Project timesheet",
  navigate: {
    path: [
      {
        name: "Timesheets",
        path: "/app/projects/timesheets",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
